import client from '../client';

export async function list() {
  return client.get('/maestro/api/v1/containers');
}
